

function currencyManagement() {

  let CurrencyManagement = [
    {
      name: "Currency Management",
      icon: "Currency Management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "marketplace",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/currency-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const currencyMaster = () => {
    const profileArr = [
      {
        path: "/index/currency-master",
        name: "Currency Master",
        icon: "Currency Master",
        logoName: "currency master",
        flag: "CURRENCY MASTER",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const conversionRate = () => {
    const mybanksArr = [
      {
        path: "/index/conversion-rate",
        name: "Conversion Rate",
        icon: "Conversion Rate",
        logoName: "conversion rate",
        flag: "CONVERSION RATE",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  let a = dashboard();
  let b = currencyMaster();
  let c = conversionRate();
  CurrencyManagement[0].items = [...a, ...b, ...c];

  return CurrencyManagement;
}

export default currencyManagement;
